import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { del, put, type Repo } from '../services/api';
import { useAuth } from '../hooks/AuthContext';
import { Icon } from './Icon';

export function StarButton({ repo, onChange }: { repo: Repo; onChange?: () => void }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [value, setValue] = useState(repo);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => setValue(repo), [repo]);
  const starred = value.starredByViewer ?? false;
  return (
    <div className="star-control">
      <button
        className="btn sm star-button"
        disabled={busy}
        aria-pressed={starred}
        aria-label={`${starred ? 'Unstar' : 'Star'} ${repo.fullName}${value.starCount !== undefined ? `, ${value.starCount} stars` : ''}`}
        onClick={async () => {
          if (!user) {
            navigate(`/login?next=${encodeURIComponent(`/${repo.fullName}`)}`);
            return;
          }
          setBusy(true);
          setError('');
          try {
            setValue(
              await (starred
                ? del<Repo>(`/repositories/${repo.id}/star`)
                : put<Repo>(`/repositories/${repo.id}/star`, {})),
            );
            onChange?.();
          } catch (cause) {
            setError(cause instanceof Error ? cause.message : 'Could not update this star.');
          } finally {
            setBusy(false);
          }
        }}
      >
        <Icon name="star" fill={starred ? 'currentColor' : 'none'} />
        {starred ? 'Starred' : 'Star'}
        {value.starCount !== undefined && <span>{value.starCount}</span>}
      </button>
      {error && (
        <span className="hint" role="alert">
          {error}
        </span>
      )}
    </div>
  );
}
